import { BrandMark } from '@/components/ui/brand-mark'

/** Canva's official mark: the white script C on the brand's radial turquoise→purple circle. */
export function CanvaTile({ size = 24, className }: { size?: number; className?: string }) {
  return <BrandMark brand="canva" size={size} className={className} />
}
